import { Box, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";

export const UploadComponent = (props) => {
  const { setFieldValue, fieldName } = props;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      const fileNames = acceptedFiles.map(({ name }) => {
        const parts = name.split(/\./g);
        const extension = parts.length > 1 ? parts.pop() : "";
        const basename = parts.join(".");
        return { name, extension, basename };
      });
      setFieldValue(
        "fileNames",
        fileNames.map(({ basename }) => basename)
      );
      setFieldValue(
        "fileExtensions",
        fileNames.map(({ extension }) => extension)
      );
      setFieldValue(fieldName, acceptedFiles);
    },
  });
  return (
    <Box
      sx={{
        borderRadius: 1,
        minHeight: 40,
        textAlign: "center",
        py: 2,
        my: 2,
        border: isDragActive ? "1px solid #E9FCD4" : "1px dashed #ddd",
        backgroundColor: isDragActive ? "#C8E6C9" : "#FFFFFF",
      }}
      // elevation={7}
      {...getRootProps({ className: "dropzone" })}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <Typography>Drop the files here...</Typography>
      ) : (
        <Typography sx={{ cursor: "pointer" }}>
          Drag files here, or click to select files
        </Typography>
      )}
    </Box>
  );
};
